module.exports = require("@splunk/react-visualizations/utils/numberUtils");